export default [{
    header: 'Verificar',
    icon: 'CheckCircleIcon',
    children: [
        {
            title: 'Lista',
            route: 'verify-list',
            icon: 'ListIcon',
            action: 'approve',
		    resource: 'verify'
        }
    ]
}];